import { AlertOctagon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

type WebhookEndpointFormProps = {
  url: string;
  error: string | null;
  disabled: boolean;
  onUrlChange: (url: string) => void;
};

const WebhookEndpointForm = ({
  url,
  error,
  disabled,
  onUrlChange,
}: WebhookEndpointFormProps): JSX.Element => (
  <div className="flex flex-col gap-2">
    <Label htmlFor="webhook-url">URL del webhook</Label>
    <Input
      id="webhook-url"
      type="url"
      inputMode="url"
      autoComplete="off"
      spellCheck={false}
      maxLength={2048}
      placeholder="https://tu-servidor.com/webhooks/palomma"
      value={url}
      disabled={disabled}
      aria-invalid={!!error}
      aria-describedby="webhook-url-help"
      className={cn(error && "border-red-500")}
      onChange={(e) => onUrlChange(e.target.value)}
    />
    <p
      id="webhook-url-help"
      className={cn(
        "flex min-h-4 items-start gap-1 text-xs",
        error ? "text-red-600" : "text-gray-600"
      )}
    >
      {error ? (
        <>
          <AlertOctagon className="mt-px size-3.5 shrink-0" />
          {error}
        </>
      ) : (
        "Debe empezar por https://. Enviamos cada evento como un POST con JSON."
      )}
    </p>
  </div>
);

export default WebhookEndpointForm;
